import { useState } from "react";

const useBillingReport = () => {
  const [showBillingReportModal, setShowBillingReportModal] = useState(false);

  const closeModal = () => setShowBillingReportModal(false);
  const openModal = () => setShowBillingReportModal(true);

  return {
    showBillingReportModal,
    openModal,
    closeModal,
  };
};

export default useBillingReport;
